import { toast } from 'sonner';

/**
 * Validates API keys before sending to backend
 * @param {Object} apiKeys - Object containing API keys
 * @param {string} modelFamily - The model family (e.g., 'claude', 'gpt')
 * @returns {boolean} - Whether the validation passed
 */
export const validateApiKeys = (apiKeys, modelFamily) => {
  if (!modelFamily) return true; // Skip validation if no model selected
  
  const family = modelFamily.toLowerCase();
  
  // Check if API keys are provided for the selected model
  if ((family === 'gpt' || family === 'o1') && !apiKeys.openAIApiKey) {
    toast.error('OpenAI API key required', {
      description: 'Please add your OpenAI API key in settings to use this model.'
    });
    return false;
  }

  if (family === 'claude' && !apiKeys.anthropicApiKey) {
    toast.error('Anthropic API key required', {
      description: 'Please add your Anthropic API key in settings to use this model.'
    });
    return false;
  }

  // Basic format validation
  if (apiKeys.openAIApiKey && !apiKeys.openAIApiKey.startsWith('sk-')) {
    toast.error('Invalid OpenAI API key format', {
      description: 'OpenAI API keys should start with "sk-"'
    });
    return false;
  }

  if (apiKeys.anthropicApiKey && !apiKeys.anthropicApiKey.startsWith('sk-ant-')) {
    toast.error('Invalid Anthropic API key format', {
      description: 'Anthropic API keys should start with "sk-ant-"'
    });
    return false;
  }

  return true;
};

/**
 * Masks API keys for display
 * @param {string} apiKey - The API key to mask
 * @returns {string} - Masked API key
 */
export const maskApiKey = (apiKey) => {
  if (!apiKey || apiKey.length < 8) return apiKey;
  
  const start = apiKey.substring(0, 7);
  const masked = '*'.repeat(Math.max(0, apiKey.length - 11));
  const end = apiKey.substring(apiKey.length - 4);
  
  return `${start}${masked}${end}`;
};